import { routerStore } from '../state/router-store';
import { constructRoutingKey, findTopLevelRoutingKey, RoutingKeyPointers, RoutingKeys } from '../entities/routing-key';
import animationManager from './animations/animation-manager';
import { setDealerCookieInfo } from './dealer-service';

export const getCurrentRoute = (): string => {
  const { routingKeyHistory, routingKeyPointer } = routerStore.state;
  return routingKeyHistory[routingKeyPointer] || '';
};

export const getAnimatedRoute = (): string => {
  const { animatingHistory, animatingPointer } = routerStore.state;
  return animatingHistory[animatingPointer] || '';
};

export const shouldShowBackButton = (section: string): boolean => {
  const sectionKey = routerStore.state.routingKeyHistory.indexOf(section);

  return sectionKey >= RoutingKeyPointers.LEVEL_TWO;
};

function currentRouteComes({ from }: { from: string }): boolean {
  return findTopLevelRoutingKey(getCurrentRoute()) === from;
}

export const goTo = (...routes: string[]): void => {
  if (!animationManager.isPlayingAny()) {
    const newHistory = [RoutingKeys.MAIN_MENU, ...routes];
    routerStore.state.routingKeyPointer = routes.length;
    routerStore.state.routingKeyHistory = newHistory;
  }
};

export const back = (): void => {
  if (!animationManager.isPlayingAny()) {
    if (currentRouteComes({ from: RoutingKeys.DEALER_SEARCH })) {
      setDealerCookieInfo(null);
    }
    routerStore.state.routingKeyPointer = routerStore.state.routingKeyPointer - 1;
  }
};

export const pop = (): void => {
  if (!animationManager.isPlayingAny()) {
    if (isNavigatingBackwards()) routerStore.state.routingKeyHistory.pop();
  }
};

export const addRoute = (newRoute: string[]): void => {
  if (!animationManager.isPlayingAny()) {
    const newHistory = [...routerStore.state.routingKeyHistory, constructRoutingKey(getCurrentRoute(), ...newRoute)];
    routerStore.state.routingKeyPointer = newHistory.length - 1;
    routerStore.state.routingKeyHistory = newHistory;
  }
};

export const reset = (): void => {
  if (!animationManager.isPlayingAny()) {
    routerStore.state.routingKeyPointer = -1;
  }
};

export const isNavigatingBackwards = (): boolean => {
  return routerStore.state.routingKeyPointer < routerStore.state.routingKeyHistory.length - 1;
};

export const isAnimating = (): boolean => {
  const { routingKeyPointer, animatingPointer } = routerStore.state;
  return routingKeyPointer !== animatingPointer;
};

export const isAnimatingForward = (): boolean => {
  const { routingKeyPointer, animatingPointer } = routerStore.state;

  return routingKeyPointer > animatingPointer;
};

export const isAnimatingBackward = (): boolean => {
  const { routingKeyPointer, animatingPointer } = routerStore.state;
  return routingKeyPointer < animatingPointer;
};

export const isAnimatingSameLevel = (): boolean => {
  const { animatingHistory, routingKeyHistory, animatingPointer, routingKeyPointer } = routerStore.state;

  return animatingHistory !== routingKeyHistory && animatingPointer === routingKeyPointer;
};

export const isOpening = (): boolean => {
  return (
    routerStore.state.animatingPointer === RoutingKeyPointers.LEVEL_ZERO && routerStore.state.routingKeyPointer >= 0
  );
};

export const isOpened = (): boolean => {
  return !isClosed();
};

export const isClosed = (): boolean => {
  return (
    routerStore.state.routingKeyPointer === RoutingKeyPointers.LEVEL_ZERO &&
    routerStore.state.animatingPointer === RoutingKeyPointers.LEVEL_ZERO
  );
};
export const isClosing = (): boolean => {
  return routerStore.state.routingKeyPointer === -1 && routerStore.state.animatingPointer >= 0;
};

export const isResized = (): boolean => {
  return routerStore.state.animatingBreakpoint !== routerStore.state.breakpoint;
};

export const syncAnimation = () => {
  routerStore.state.animatingPointer = routerStore.state.routingKeyPointer;
  routerStore.state.animatingHistory = routerStore.state.routingKeyHistory;
  routerStore.state.animatingBreakpoint = routerStore.state.breakpoint;
};
